import request from 'graphql-request';
import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { GetNewsDocument, GetNewsQuery } from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';
import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { AppNewsCollection } from '@phoenix/core/frontend/shared/domain/static-content/static-content-api.model';
import { Asset } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';

export const useAemNews = (limit = 5) => {
  const {
    auth: { user },
  } = useCore();
  const { 'aem-news': aemNewsFlagEnabled } = useFlags();

  const mapToAppNews = (query?: GetNewsQuery): AppNewsCollection | void =>
    query?.news?.items.reduce(
      (acc, { headline, previewText, contentUrl, imageUrl, targetSystem }) =>
        targetSystem.includes('WEB')
          ? [
              ...acc,
              {
                header: headline,
                contentText: previewText,
                link: contentUrl ?? null,
                image: { url: imageUrl ?? null } as Asset,
              },
            ]
          : acc,
      []
    );

  const getNewsQueryFn = async () =>
    request(process.env.NEXT_PUBLIC_TOOL_SHED_GRAPHQL_BASE_URL as string, GetNewsDocument, {
      limit,
      locale: user?.locale as string,
    });

  return useQuery([`aemNews${aemNewsFlagEnabled ? 'On' : 'Off'}`], getNewsQueryFn, {
    enabled: !!user?.locale && !!aemNewsFlagEnabled,
    select: mapToAppNews,
  });
};
